import { AbilityBuilder, createMongoAbility } from '@casl/ability';
export const getUserAbilities = (role, client = null) => {
  const { can, build } = new AbilityBuilder(createMongoAbility);
  can('read', 'session');
  can('read', 'player');
  can('read', 'game');
  if (role == 'user') {
    can('read', 'client');
    can('read', 'operator');
    can('read', 'brand');
    can('read', 'suspicious');
    can('read', 'fin-report');
    can('read', 'cost-report');
  }
  if (role == 'admin' || role == 'client') {
    can('manage', 'game');
    can('manage', 'email_metrics');
    can('manage', 'operator');
    can('manage', 'user');
  }
  if (role == 'client' || role == 'admin' || role == 'operator') {
    can('manage', 'brand');
  }
  if (role == 'admin' || role == 'client' || role == 'operator' || role == 'brand') {
    can('manage', 'leaderboard');
  }
  can('read', 'metric');
  if (role == 'admin' && !client) {
    can('manage', 'all');
    can('read', 'suspicious');
    can('read', 'fin-report');
    can('read', 'cost-report');
  }
  if (!role == 'client') {
    can('manage', 'AethirChecks');
  }
  return build();
};
